<template>
    <el-container>
        <el-header>
            <div>
                Company Info
            </div>
            <div>
                <el-button @click.native.prevent="updateCompanyInfo" type="success" :disabled="buttonDisabledStatus">Save
                </el-button>
            </div>
        </el-header>

        <el-main>

            <div>
                <el-form class="settings-detail-form" label-position="left" label-width="160px" :model="companyInfo" v-loading="loading">
                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Details</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item label="Business name">
                                    <el-input placeholder="Business name" v-model="companyInfo.companyName"></el-input>
                                </el-form-item>
                                <el-form-item label="Name">
                                    <el-input placeholder="" v-model="companyInfo.contactName"></el-input>
                                </el-form-item>
                                <el-form-item label="Phone">
                                    <el-input placeholder="" v-model="companyInfo.phone"></el-input>
                                </el-form-item>
                                <el-form-item label="Email">
                                    <el-input placeholder="" v-model="companyInfo.companyEmail"></el-input>
                                </el-form-item>
                                <el-form-item label="Business Number">
                                    <el-input placeholder="" v-model="companyInfo.businessNumber"></el-input>
                                </el-form-item>
                                <el-form-item label="Tax N°">
                                    <el-input placeholder="" v-model="userSetting.taxRegNValue"></el-input>
                                </el-form-item>
                                <el-divider></el-divider>

                                <div style="display: flex" v-for="(value,index) in userFieldList" :key="'user-field-' + index">
                                    <el-input style="width: 20%" type="text" v-model="value.fieldKey"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="value.fieldValue"></el-input>
                                    <el-button style="color: red;margin-left: 2%" type="text" @click="deleteUserField(index)" circle>delete</el-button>
                                </div>
                                <div style="margin-top: 12px;margin-left: 1%">
                                    <el-button type="primary" @click="addNewField" circle icon="el-icon-plus">
                                    </el-button>
                                    <el-button type="text" @click="addNewField">
                                        Add new field
                                    </el-button>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row class="margin_top_card">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Address</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item label="Line1">
                                    <el-input placeholder="" v-model="companyInfo.addressOne"></el-input>
                                </el-form-item>
                                <el-form-item label="Line2">
                                    <el-input placeholder="" v-model="companyInfo.addressTwo"></el-input>
                                </el-form-item>
                                <el-form-item label="Line3">
                                    <el-input placeholder="" v-model="companyInfo.addressThree"></el-input>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row class="margin_top_card">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Currency</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item label="Currency">
                                    <el-select v-model="userSetting.currencyName" placeholder="" @change="changeCurrency">
                                        <el-option
                                                v-for=" (value, key) in currencySymbolMap"
                                                :key="key"
                                                :label="key+' ('+value+') '"
                                                :value=key></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Symbol">
                                    <el-input placeholder="" :readonly="symbolReadonly" :disabled="symbolReadonly" v-model="userSetting.currency"></el-input>
                                </el-form-item>
                                <el-form-item label="Placement">
                                    <el-radio-group v-model="userSetting.currencyPlacementAtBefore" size="small">
                                        <el-radio-button label="1">Before</el-radio-button>
                                        <el-radio-button label="0">After</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Thousand Symbol">
                                    <el-input placeholder="" v-model="userSetting.currencyThousandSymbol"></el-input>
                                </el-form-item>
                                <el-form-item label="Decimal Symbol">
                                    <el-input placeholder="" v-model="userSetting.currencyDeciamlSymbol"></el-input>
                                </el-form-item>
                                <el-form-item label="Decimal Places">
                                    <el-radio-group v-model="userSetting.currencyDecimalPlaces">
                                        <el-radio-button label="0"></el-radio-button>
                                        <el-radio-button label="1"></el-radio-button>
                                        <el-radio-button label="2"></el-radio-button>
                                        <el-radio-button label="3"></el-radio-button>
                                        <el-radio-button label="4"></el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-divider></el-divider>
                                <el-form-item label="Example">
                                    <span>{{ xiaoshudianfenge1(1000.00000,userSetting)}}</span>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row class="margin_top_card">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Terms</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item label="Terms">
                                    <el-select class="test111" v-model="userSetting.term" placeholder="">
                                        <el-option label="Same Day" value="0"></el-option>
                                        <el-option label="7 Days" value="7"></el-option>
                                        <el-option label="14 Days" value="14"></el-option>
                                        <el-option label="21 Days" value="21"></el-option>
                                        <el-option label="30 Days" value="30"></el-option>
                                        <el-option label="45 Days" value="45"></el-option>
                                        <el-option label="60 Days" value="60"></el-option>
                                        <el-option label="90 Days" value="90"></el-option>
                                        <el-option label="180 Days" value="180"></el-option>
                                        <el-option label="365 Days" value="365"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row class="margin_top_card">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Payment Info</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>

                                <el-form-item label="Display on invoices">
                                    <el-switch v-model="companyInfo.showPaymentInfoOnPDF" :active-value=1 :inactive-value=0></el-switch>
                                </el-form-item>

                                <div>
                                    <el-input style="width: 20%" type="text" :disabled="true" placeholder="Title"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="companyInfo.paymentInstructionsLabel"></el-input>
                                </div>

                                <div style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.paypalAddressTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.paypalEmail"></el-input>
                                </div>
                                <div style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.makeChequesPaybleToTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.businessName"></el-input>
                                </div>
                                <div style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.bankTransferTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.bandInfo"></el-input>
                                </div>
                                <div style="margin-top: 15px;margin-bottom: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.paymentInfoOtherTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.additionalPaymentInfo"></el-input>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>


                    <el-row class="margin_top_card">
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>Job Details</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <div style="display: flex" v-for="(value,index) in jobDetailsListList" :key="'job-detail-' + index">
                                    <el-input style="width: 20%" type="text" v-model="value.fieldKey"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="value.fieldValue"></el-input>
                                    <el-button style="color: red;margin-left: 2%" type="text" @click="deletejobDetail(index)" circle>delete</el-button>
                                </div>
                                <div style="margin-top: 12px;margin-left: 1%">
                                    <el-button type="primary" @click="addJobDetailField" circle icon="el-icon-plus">
                                    </el-button>
                                    <el-button type="text" @click="addJobDetailField">
                                        add new field
                                    </el-button>
                                </div>

                            </el-card>
                        </el-col>
                    </el-row>


                </el-form>

            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {timest} from '@/utils/validate'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {syncCompanySelection} from '@/utils/company'

    export default {
        methods: {
            xiaoshudianfenge1: xiaoshudianfenge,
            queryUserSetting() {
                this.loading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    // firstq:斤斤计较 && first:啊啊啊&&快看看:京津冀
                    if (response.data.errorCode === 0) {
                        let selectedData = syncCompanySelection(response.data);
                        if (selectedData == null) {
                            this.loading = false;
                            return;
                        }

                        that.userSetting = selectedData.setting;
                        that.userSetting.term = that.userSetting.term.toString();
                        // that.currency = that.userSetting.currency;
                        if (this.userSetting.currencyName === "Other") {
                            this.symbolReadonly = false;
                        }
                        that.companyInfo = selectedData.company;

                        let haveWebSite = 0;

                        if ("" != selectedData.company.otherFields) {
                            let splitOtherFieldList = selectedData.company.otherFields.split("&&");
                            for (let i = 0; i < splitOtherFieldList.length; i++) {
                                let strings = splitOtherFieldList[i].split(":");
                                if (strings[0] === "Website") {
                                    haveWebSite = 1;
                                }
                                let newField = {
                                    fieldKey: strings[0],
                                    fieldValue: strings[1]
                                };
                                this.userFieldList.push(newField);
                            }
                        }
                        if (haveWebSite === 0) {
                            let newField = {
                                fieldKey: "Website",
                                fieldValue: ""
                            };
                            this.userFieldList.push(newField);
                        }

                        if (null != selectedData.company.jobDetails && "" != selectedData.company.jobDetails) {

                            let splitJobDetailsList = selectedData.company.jobDetails.split("&&");
                            for (let i = 0; i < splitJobDetailsList.length; i++) {
                                let strings = splitJobDetailsList[i].split(":");
                                let newField = {
                                    fieldKey: strings[0],
                                    fieldValue: strings[1]
                                };
                                this.jobDetailsListList.push(newField);
                            }
                        }


                        //初始化页面后需要将watch里的监控是否有字段修改改为0,不然每次都会弹是否保存的框
                        this.$watch('userSetting', function () {
                            this.pageHaveChange = 1;
                        }, {deep: true});
                        this.$watch('companyInfo', function () {
                            this.pageHaveChange = 1;
                        }, {deep: true});

                    }
                    this.loading = false;

                })
            },
            updateCompanyInfo(flag, next) {
                let self = this;
                this.loading = true;
                self.buttonDisabledStatus = true;

                let userFieldListString = "";
                for (let i = 0; i < this.userFieldList.length; i++) {
                    if (this.userFieldList[i].fieldKey === '' && this.userFieldList[i].fieldValue === '') {
                        continue;
                    }
                    userFieldListString += this.userFieldList[i].fieldKey + ":" + this.userFieldList[i].fieldValue + "&&";
                }
                let jobDetailString = "";
                for (let i = 0; i < this.jobDetailsListList.length; i++) {
                    if (this.jobDetailsListList[i].fieldKey === '' && this.jobDetailsListList[i].fieldValue === '') {
                        continue;
                    }
                    jobDetailString += this.jobDetailsListList[i].fieldKey + ":" + this.jobDetailsListList[i].fieldValue + "&&";
                }

                let settingInfo = {
                    term: this.userSetting.term,
                    taxRegNValue: this.userSetting.taxRegNValue,
                    paypalEmail: this.userSetting.paypalEmail,
                    businessName: this.userSetting.businessName,
                    bandInfo: this.userSetting.bandInfo,
                    additionalPaymentInfo: this.userSetting.additionalPaymentInfo,
                    currencyPlacementAtBefore: this.userSetting.currencyPlacementAtBefore,
                    currencyThousandSymbol: this.userSetting.currencyThousandSymbol,
                    currencyDeciamlSymbol: this.userSetting.currencyDeciamlSymbol,
                    currencyDecimalPlaces: this.userSetting.currencyDecimalPlaces,
                    currency: this.userSetting.currency,
                    currencyCountry: this.currencyJianChenMap[this.userSetting.currencyName],
                    currencyName: this.userSetting.currencyName,
                    innerUUID: this.userSetting.innerUUID,
                    accessDate: timest()
                };
                let companyInfo = {
                    companyName: this.companyInfo.companyName,
                    contactName: this.companyInfo.contactName,
                    phone: this.companyInfo.phone,
                    companyEmail: this.companyInfo.companyEmail,
                    businessNumber: this.companyInfo.businessNumber,
                    term: this.companyInfo.term,
                    addressOne: this.companyInfo.addressOne,
                    addressTwo: this.companyInfo.addressTwo,
                    addressThree: this.companyInfo.addressThree,
                    showPaymentInfoOnPDF: this.companyInfo.showPaymentInfoOnPDF,
                    paypalAddressTitle: this.companyInfo.paypalAddressTitle,
                    makeChequesPaybleToTitle: this.companyInfo.makeChequesPaybleToTitle,
                    bankTransferTitle: this.companyInfo.bankTransferTitle,
                    paymentInfoOtherTitle: this.companyInfo.paymentInfoOtherTitle,
                    otherFields: userFieldListString.substr(0, userFieldListString.length - 2),
                    jobDetails: jobDetailString.substr(0, jobDetailString.length - 2),
                    innerUUID: this.companyInfo.innerUUID,
                    paymentInstructionsLabel: this.companyInfo.paymentInstructionsLabel,
                    accessDate: timest()
                }
                this.$axios.post('update_setting_and_company', {
                    params: {"settingReq": settingInfo, "companyReq": companyInfo}

                }).then(response => {
                    this.loading = false;
                    self.buttonDisabledStatus = false;
                    if (response.data.errorCode === 0) {

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.term = this.userSetting.term;
                        tempUserSetting.taxRegNValue = this.userSetting.taxRegNValue;
                        tempUserSetting.paypalEmail = this.userSetting.paypalEmail;
                        tempUserSetting.businessName = this.userSetting.businessName;
                        tempUserSetting.bandInfo = this.userSetting.bandInfo;
                        tempUserSetting.additionalPaymentInfo = this.userSetting.additionalPaymentInfo;
                        tempUserSetting.currencyPlacementAtBefore = this.userSetting.currencyPlacementAtBefore;
                        tempUserSetting.currencyThousandSymbol = this.userSetting.currencyThousandSymbol;
                        tempUserSetting.currencyDeciamlSymbol = this.userSetting.currencyDeciamlSymbol;
                        tempUserSetting.currencyDecimalPlaces = this.userSetting.currencyDecimalPlaces;
                        tempUserSetting.currency = this.userSetting.currency;
                        tempUserSetting.currencyCountry = this.currencyJianChenMap[this.userSetting.currencyName];
                        tempUserSetting.currencyName = this.userSetting.currencyNam;
                        localStorage.setItem('userSetting', JSON.stringify(tempUserSetting));

                        let tempCompany = JSON.parse(localStorage.getItem('userCompany'));
                        tempCompany.companyName = this.companyInfo.companyName;
                        tempCompany.contactName = this.companyInfo.contactName;
                        tempCompany.phone = this.companyInfo.phone;
                        tempCompany.companyEmail = this.companyInfo.companyEmail;
                        tempCompany.businessNumber = this.companyInfo.businessNumber;
                        tempCompany.term = this.companyInfo.term;
                        tempCompany.addressOne = this.companyInfo.addressOne;
                        tempCompany.addressTwo = this.companyInfo.addressTwo;
                        tempCompany.addressThree = this.companyInfo.addressThree;
                        tempCompany.showPaymentInfoOnPDF = this.companyInfo.showPaymentInfoOnPDF;
                        tempCompany.paypalAddressTitle = this.companyInfo.paypalAddressTitle;
                        tempCompany.makeChequesPaybleToTitle = this.companyInfo.makeChequesPaybleToTitle;
                        tempCompany.bankTransferTitle = this.companyInfo.bankTransferTitle;
                        tempCompany.paymentInfoOtherTitle = this.companyInfo.paymentInfoOtherTitle;
                        tempCompany.paymentInstructionsLabel = this.companyInfo.paymentInstructionsLabel;
                        tempCompany.otherFields = userFieldListString.substr(0, userFieldListString.length - 2);
                        tempCompany.jobDetails = jobDetailString.substr(0, jobDetailString.length - 2);

                        localStorage.setItem('userCompany', JSON.stringify(tempCompany));

                        this.pageHaveChange = 0;
                        this.$message({
                            message: 'update success',
                            type: 'success',
                            duration: "2000"
                        });
                        if (flag === 100) {
                            next();
                        }
                    }
                }).catch(function () {
                    self.loading = false;
                    self.buttonDisabledStatus = false;
                })
            },
            changeCurrency: function () {
                this.userSetting.currency = this.currencySymbolMap[this.userSetting.currencyName];
                if (this.userSetting.currencyName === "Other") {
                    this.symbolReadonly = false;
                } else {
                    this.symbolReadonly = true;
                }
            },
            addNewField: function () {
                let newField = {
                    fieldKey: "",
                    fieldValue: ""
                };
                this.userFieldList.push(newField);
            },
            deleteUserField: function (index) {

                this.userFieldList.splice(index, 1);
            }
            ,
            addJobDetailField: function () {
                let newField = {
                    fieldKey: "",
                    fieldValue: ""
                };
                this.jobDetailsListList.push(newField);
            },
            deletejobDetail: function (index) {

                this.jobDetailsListList.splice(index, 1);
            }

        },
        data() {
            return {
                companyInfo: {},
                userSetting: {},
                buttonDisabledStatus: false,
                currencySymbolMap: {
                    "Albanian Lek": "Lek", "Argentine Peso": "$", "Australian Dollar": "$",
                    "Bahamian Dollar": "$", "Barbadian Dollar": "$", "Belize Dollar": "BZ$", "Bermudan Dollar": "$", "Bolivian Boliviano": "Bs", "Brazilian Real": "R$", "British Pound Sterling": "£",
                    "Canadian Dollar": "$", "Cayman Islands Dollar": "$", "Chilean Peso": "$",
                    "Colombian Peso": "$", "Costa Rican Colón": "₡", "Croatian Kuna": "kn", "Czech Republic Koruna": "Kč",
                    "Danish Krone": "kr", "Dominican Peso": "$",
                    "East Caribbean Dollar": "$", "Euro": "€",
                    "Guatemalan Quetzal": "Q", "Guyanaese Dollar": "$",
                    "Honduran Lempira": "L", "Hungarian Forint": "Ft",
                    "Icelandic Króna": "kr", "Indian Rupee": "Rs", "Indonesian Rupiah": "Rp",
                    "Jamaican Dollar": "$",
                    "Malaysian Ringgit": "RM", "Mexican Peso": "$",
                    "New Zealand Dollar": "$", "Nicaraguan Córdoba": "C$", "Norwegian Krone": "kr",
                    "Oman Rials": "OMR",
                    "Panamanian Balboa": "B/．", "Paraguayan Guarani": "Gs", "Peruvian Nuevo Sol": "S/．", "Polish Zloty": "zł",
                    "Romanian Leu": "lei",
                    "Singapore Dollar": "$", "South African Rand": "R", "Swedish Krona": "kr",
                    "Swiss Franc": "CHF",
                    "Thai Baht": "฿", "Turkish Lira": "TL",
                    "United Arab Emirates": "AED", "Uruguayan Peso": "$", "US Dollar": "$",
                    "Venezuelan Bolívar": "Bs．",
                    "Other": "Other"
                },
                currencyJianChenMap: {
                    "Albanian Lek": "ALL", "Argentine Peso": "ARS", "Australian Dollar": "AUD",
                    "Bahamian Dollar": "BSD", "Barbadian Dollar": "BBD", "Belize Dollar": "BZD", "Bermudan Dollar": "BMD", "Bolivian Boliviano": "BOB", "Brazilian Real": "BRL", "British Pound Sterling": "GBP",
                    "Canadian Dollar": "CAD", "Cayman Islands Dollar": "KYD", "Chilean Peso": "CLP",
                    "Colombian Peso": "COP", "Costa Rican Colón": "CRC", "Croatian Kuna": "HRK", "Czech Republic Koruna": "CZK",
                    "Danish Krone": "DKK", "Dominican Peso": "DOP",
                    "East Caribbean Dollar": "XCD", "Euro": "EUR",
                    "Guatemalan Quetzal": "GTO", "Guyanaese Dollar": "GYD",
                    "Honduran Lempira": "HNL", "Hungarian Forint": "HUF",
                    "Icelandic Króna": "ISK", "Indian Rupee": "INR", "Indonesian Rupiah": "IDR",
                    "Jamaican Dollar": "JMD",
                    "Malaysian Ringgit": "MYR", "Mexican Peso": "MXN",
                    "New Zealand Dollar": "NZD", "Nicaraguan Córdoba": "NIO", "Norwegian Krone": "NOK",
                    "Oman Rials": "OMR",
                    "Panamanian Balboa": "PAB", "Paraguayan Guarani": "PYG", "Peruvian Nuevo Sol": "PEN", "Polish Zloty": "PLN",
                    "Romanian Leu": "RON",
                    "Singapore Dollar": "SGD", "South African Rand": "ZAR", "Swedish Krona": "SEK",
                    "Swiss Franc": "CHF",
                    "Thai Baht": "THB", "Turkish Lira": "TRY",
                    "United Arab Emirates": "AED", "Uruguayan Peso": "UYU", "US Dollar": "USD",
                    "Venezuelan Bolívar": "VEF",
                    "Other": "Other"
                },
                currency: "",
                symbolReadonly: true,
                userFieldList: [],
                jobDetailsListList: [],
                loading: false,
                pageHaveChange: 0
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false)
                this.$confirm('You have unsaved changes. Would you like to save or discard them?', 'Save changes?', {
                    confirmButtonText: 'Save',
                    cancelButtonText: 'Discard',
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.updateCompanyInfo(100, next);
                }).catch(function () {
                    next();
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    /deep/ .el-input__inner {
        /*width: 60%;*/
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    /deep/ .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 15%;
        text-align: left;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-left: 10%;
        margin-top: 20px;
    }

    .el-select {
        display: block;
    }

    /deep/ .el-input__suffix {
        left: 0;
    }

    /deep/ .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-input {
        width: 60%;
    }

    .settings-detail-form >>> .el-form-item__label {
        position: relative;
        left: 1%;
        text-align: left;
    }

    /deep/ .el-input__suffix {
        text-align: right;
    }

    .margin_top_card {
        margin-top: 20px;
    }

</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
